import Table from "../../../components/ui/Table";
import usePaginate from "../../../hooks/api/usePaginate";
import apiRequest from "../../../utils/apiRequest";
import Pagination from "../../../components/ui/Pagination";
import {
  FaBoxOpen,
  FaCalendarAlt,
  FaEdit,
  FaEye,
  FaRupeeSign,
} from "react-icons/fa";
import useModal from "../../../hooks/ui/useModal";
import Modal from "../../../components/ui/utils/Modal";
import ViewOrder from "../../../components/user/order/ViewOrder";
import OrderReport from "./OrderReport";
import { getStatusBadgeClass } from "./OrderList";
import SelectField from "../../ui/form/SelectField";
import useFormInput from "../../../hooks/form/useFormInput";
import { useEffect, useRef } from "react";
import { formatDate } from "../../../utils/helper";
import ProductDetails from "./ProductDetails";
import { HiStatusOnline } from "react-icons/hi";
const OrderListPartner = () => {
  const {
    currentPage,
    data,
    error,
    limit,
    loading,
    setPage,
    fetchData,
    setSorting,
    sort,
    totalItems,
    totalPages,
    setFilters,
  } = usePaginate({
    apiMethod: apiRequest.getOrders,
    dataKey: "orders",
  });

  const { isOpen, openModal, closeModal, actionType } = useModal();

  const handleSort = (field) => {
    const order =
      sort.sortField === field && sort.sortOrder === "asc" ? "desc" : "asc";
    setSorting({ sortField: field, sortOrder: order });
  };
  const searchInitialValues = { status: "" };
  const { values, handleChange, setValues } = useFormInput(searchInitialValues);
  const debounceRef = useRef(null);
  useEffect(() => {
    if (values.status !== undefined) {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
      debounceRef.current = setTimeout(() => {
        const filters = {};

        if (values.status) {
          filters.status = values?.status;
        }
        setFilters(filters);
      }, 500);
      return () => clearTimeout(debounceRef.current);
    }
  }, [values.status]);
  return (
    <>
      <div className="p-4 bg-white rounded">
        <div className="flex items-center justify-between pb-4">
          <h1 className="text-xl font-semibold">My Orders</h1>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-[1fr_100px] gap-2 my-2">
          <SelectField
            id="status"
            name="status"
            value={values.status}
            onChange={handleChange}
            options={[
              "Dispatched",
              "Cancelled",
              "Lead Requested",
              "Requested to Cancel",
              "Rejected Cancellation",
            ]?.map((item) => ({
              value: item,
              label: item,
            }))}
            placeholder="Order Status"
          />
          <button
            className="py-1 text-white rounded bg-emerald-600 hover:bg-emerald-800"
            onClick={() => setValues(searchInitialValues)}
          >
            Clear
          </button>
        </div>
        <Table
          headers={[
            { label: "Order ID", key: "orderId", sorting: true },
            { label: "Status", key: "status", sorting: true },
            { label: "Total Amount", key: "totalAmount", sorting: true },
            { label: "Commission", key: "commission", sorting: false },
            {
              label: "Expected Commission",
              key: "expectedCommission",
              sorting: false,
            },
            { label: "Created At", key: "createdAt", sorting: true },
            { label: "Action", key: "Action", sorting: false },
          ]}
          loading={loading}
          handleSort={handleSort}
          sort={sort}
          error={error}
          cols={7}
          renderRow={
            <tbody className="bg-white divide-y divide-gray-200">
              {data?.map((order) => (
                <tr key={order._id} className="transition hover:bg-gray-50">
                  <td className="px-4 py-4 text-sm font-medium text-gray-900">
                    <div className="flex items-center">
                      <FaBoxOpen className="mr-2 text-green-500" />
                      <span className="font-mono">{order?.orderId}</span>
                    </div>
                  </td>
                  <td className="px-4 py-4">
                    <div className="flex items-center">
                      <HiStatusOnline className="mr-2 text-gray-500" />
                      <span
                        className={`text-xs font-semibold text-nowrap px-3 py-1 rounded ${getStatusBadgeClass(
                          order?.reports[order?.reports?.length - 1]?.status ||
                            ""
                        )}`}
                      >
                        {order?.reports[order?.reports?.length - 1]?.status}
                      </span>
                    </div>
                  </td>
                  <td className="px-4 py-4 text-sm font-medium text-gray-900">
                    <div className="flex items-center">
                      <FaRupeeSign className="mr-1 text-gray-600" size={12} />
                      {order.totalAmount.toLocaleString("en-IN")}
                    </div>
                  </td>
                  <td className="px-3 py-3 text-xs">
                    ₹{order.commission ?? 0}
                  </td>
                  <td className="px-3 py-3 text-xs">
                    ₹{order.expectedCommission ?? 0}
                  </td>
                  <td className="px-4 py-4 text-sm text-gray-500">
                    <div className="flex items-center">
                      <FaCalendarAlt className="mr-2 text-gray-400" size={12} />
                      {formatDate(order.createdAt)}
                    </div>
                  </td>
                  <td className="px-3 py-3">
                    <div className="flex justify-center gap-3">
                      <button
                        onClick={() =>
                          openModal({
                            type: "products",
                            data: { state: order },
                          })
                        }
                        className="px-3 py-1 text-xs text-white transition-colors bg-green-600 rounded-md hover:bg-green-700"
                        title="View Products"
                      >
                        Products
                      </button>
                      <button
                        onClick={() =>
                          openModal({
                            type: "report",
                            data: { state: order },
                          })
                        }
                        className="text-primary"
                        title="view"
                      >
                        <FaEdit size={18} />
                      </button>
                      <button
                        onClick={() =>
                          openModal({
                            type: "view",
                            data: { state: order },
                          })
                        }
                        className="text-primary"
                        title="view"
                      >
                        <FaEye size={18} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          }
        />

        {totalPages > 1 && (
          <Pagination
            pagination={{
              currentPage,
              totalPages,
              totalItems: totalItems,
              perPage: limit,
            }}
            handlePageChange={setPage}
            loading={loading}
          />
        )}
      </div>
      <Modal
        isOpen={isOpen}
        onClose={closeModal}
        size={actionType?.type === "products" ? "extralarge" : "lg"}
        overflow={"overflow-y-scroll"}
      >
        {actionType?.type === "view" && (
          <ViewOrder order={actionType?.data?.state} closeModal={closeModal} />
        )}
        {actionType?.type === "report" && (
          <OrderReport
            order={actionType?.data?.state}
            closeModal={closeModal}
            fetchData={fetchData}
          />
        )}
        {actionType?.type === "products" && (
          <ProductDetails
            order={actionType?.data?.state}
            closeModal={closeModal}
          />
        )}
      </Modal>
    </>
  );
};

export default OrderListPartner;
